import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';
import projets from '../projets';
import ProjetCard from './ProjetCard';

const Projets = () => {
  const { t } = useContext(LanguageContext);
  return (
    <div className="page container">
      <header className="page__head">
        <h1>{t.projects.title}</h1>
        <p>{t.projects.intro}</p>
      </header>
      <div className="grid grid--2">
        {projets.map((p, i) => (
          <ProjetCard key={p.slug} projet={p} delay={(i % 2) * 100} />
        ))}
      </div>
    </div>
  );
};

export default Projets;
